export const RepairStatus = [
  { value: "", label: "Select Status" },
  { value: "Pending", label: "Pending" },
  { value: "Completed", label: "Completed" },
  { value: "OnHold", label: "On Hold" },
  { value: "WaitingForInvoice", label: "Waiting For Invoice" },
];

export const OnHoldRepairStatus = [
  { value: "", label: "Select Status" },
  { value: "OnHold", label: "On Hold" },
  { value: "Pending", label: "Pending" },
];
